import type { ClikArtItem } from '@/api/types/clikart'
import {
  PlacementDragGhost,
  type PlacementDragGhostProps,
} from '@/components/app/placement/placement-drag-ghost'

type ClikArtDragGhostProps = Omit<PlacementDragGhostProps, 'imageUrl' | 'label'> & {
  item: ClikArtItem
}

/** `PlacementDragGhost` for a ClikArt item — see that file for the positioning and flyback logic. */
export function ClikArtDragGhost({ item, ...ghostProps }: ClikArtDragGhostProps) {
  return <PlacementDragGhost imageUrl={item.scrUrl} label={item.displayName} {...ghostProps} />
}
